<div class="row mb-2" *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')">
    <div class="col pl-0">
        <div widget class="card border-0 box-shadow">
            <div class="card-header transparent  text-muted">
                <h4 class="mb-0 font-header">Document</h4>
            </div>
            <div class="card-body  widget-body pb-0 pt-2 mb-4">
                <div class="row">
                    <div class="col-lg-2">
                        <div class="mt-4">
                            <button class="btn btn-sm mb-1 me-1" type="button" (click)="opennewDocument()" [disabled]="global.viewTabs" *ngIf="fp?.documentcreate"
                                data-bs-toggle="modal" data-bs-target="#DocumentsAdd">
                                New Document
                            </button>
                        </div>
                    </div>
                    <div class="col-lg-4">
                            <label >Check List</label>
                            <ng-select [(ngModel)]="checklistLid" [items]="DocumentName" style="width: 50%;" (change)="getClientDocuments();"
                                    [searchable]="true" bindLable="label" bindValue="value" [clearable]="true">
                            </ng-select>
                    </div>
                    <div class=" col-lg-4 " >
                        <div class="d-flex justify-content-between mt-4 " style="width: 50%">
                            <input type="radio" class="mb-3" name="options" [value]="'active'" [(ngModel)]="getDocumentList.validStatus"
                                [disabled]="global.viewTabs" (change)="statusChangeCall('active')" /> Active 
                            <input type="radio" class="mb-3" name="options" [value]="'all'" [(ngModel)]="getDocumentList.validStatus"
                                [disabled]="global.viewTabs" (change)="statusChangeCall('all')" />All 
                            <input type="radio" class="mb-3" name="options" [value]="'expired'" [(ngModel)]="getDocumentList.validStatus"
                                [disabled]="global.viewTabs" (change)="statusChangeCall('expired')" />Expired 
                        </div>
                    </div>
                    <div class="col-lg-2 mt-4 text-end">
                        <button type="button" (click)="Refresh()" class="btn btn-sm" 
                            [disabled]="global.globalAgencyId == null || global.globalAgencyId == '00000000-0000-0000-0000-000000000000' || global.globalAgencyId == '' || global.viewTabs">
                            <i class="fa fa-repeat"> </i>Refresh
                        </button>                        
                    </div>
                        



                    
                </div>

            </div>
        </div>
    </div>
</div>


<div class="row">
    <div class="col-lg-12">
        <ejs-grid #grid [dataSource]='data | async' [allowResizing]='true' [allowSorting]='true' [allowFiltering]='true'
            [filterSettings]='DocumentfilterOptions' allowPaging='true' [allowSorting]='true'
            *ngIf="global.globalAgencyId!=0" [pageSettings]='initialPage' [showColumnChooser]='true'
            (resizeStop)="onResizeDocuments($event)" (actionBegin)="onActionCompleteDocuments($event)"
            (dataStateChange)='dataStateChangeDocuments($event)'>
            <e-columns>
                <e-column minWidth=100 headerText="Actions" uid="action" textAlign="center">
                    <ng-template #template let-data>
                        <button class="btn btn-edit-table me-2" [disabled]="global.viewTabs" data-bs-toggle="modal" data-bs-target="#DocumentsAdd"
                            (click)="EditDocument(data)"><i class="fa fa-edit"></i></button>
                        <button class="btn btn-edit-table me-2 text-center" *ngIf="data.fileExtension=='pdf'||
                        data.fileExtension=='webp' ||
                        data.fileExtension=='png' ||
                        data.fileExtension=='jpeg' ||
                        data.fileExtension=='jpg' ||
                          data.fileExtension=='dat' ||
                          data.fileExtension=='txt'  || fp?.documentupdate" (click)="getViewDocuments(data)" [disabled]="global.viewTabs">
                            <i class="fa fa-eye"></i>
                        </button>
                        <button class="btn btn-edit-table me-2" [disabled]="global.viewTabs"
                            (click)="downloadFile(data)"><i class="fa fa-download"></i></button>
                        <button class="btn btn-delete-table" 
                            [disabled]="global.viewTabs" data-bs-toggle="modal" data-bs-target="#deletedoc"
                            (click)="setDocumentId(data)"><i class="fa fa-trash"></i></button>
                    </ng-template>
                </e-column>
                <e-column minWidth=100 field="documentName" headerText="Check List">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column minWidth=100 field="documentTitle" headerText="Document Title">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column minWidth=100 field="attachedDate" [allowFiltering]='false' headerText="Attached Date"
                    type='date' [format]='formatOptions'>
                </e-column>
                <e-column minWidth=100 field="validTill" [allowFiltering]='false' headerText="Valid Till"
                    type='date' [format]='formatOption'>
                </e-column>
                <e-column minWidth=100 field="filepath" headerText="Filepath">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column minWidth=100 field="isMNChoiceAssessment" [allowFiltering]='false' headerText="MN Choice Assessment Received"
                    type='string' >
                </e-column>
            </e-columns>
        </ejs-grid>
        <div *ngIf="DocumentDataList.length == 0" class="text-center" style="color:red">
            <p>No data available</p>
        </div>
    </div>
</div>

<span id="DocumentAddopen" data-bs-toggle="modal" data-bs-target="#DocumentsAdd"></span>
<div class="modal hide fade modalbackgrod" id="DocumentsAdd" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 *ngIf="DocumentRelation.isDocumentVerified== 'Client'" class="modal-title font-header"
                    id="exampleModalLabel"><span *ngIf="!(documentList.id!='00000000-0000-0000-0000-000000000000'&&documentList.id!=undefined&&documentList.id!=null)" >Create Client Document</span>
                    <span *ngIf="documentList.id!='00000000-0000-0000-0000-000000000000'&&documentList.id!=undefined&&documentList.id!=null">Update Client Document</span></h5>
                <h5 *ngIf="DocumentRelation.isDocumentVerified== 'Employee'" class="modal-title font-header"
                    id="exampleModalLabel"><span *ngIf="!(documentList.id!='00000000-0000-0000-0000-000000000000'&&documentList.id!=undefined&&documentList.id!=null)">Create Employee Document</span>
                    <span *ngIf="documentList.id!='00000000-0000-0000-0000-000000000000'&&documentList.id!=undefined&&documentList.id!=null">Update Employee Document</span></h5>
                

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="clientDocumentClose()">
                    <span aria-hidden="true"> </span>
                </button>
            </div>
            <div class="modal-body ">

                <div class="row">
                    <div class="col-lg-3">
                        <label style="font-weight: 600;margin-top:6px;">File<span class="super-script">*</span>
                        </label>
                    </div>
                    <div class="col-lg-7" style="display: flex;">
                        <div class="custom-file">

                          

                            <input type="file" class="custom-file-input" id="customFile" name="filename"
                            (change)="onDOCFileChanged($event.target.files);inputChangeValue()" [disabled]="documentList.id!='00000000-0000-0000-0000-000000000000'"
                         #fileInput   >

                            <label for="customFile" style="color:#004290">{{selectedDocumentFileName}}</label>
                        </div>
                       
                    </div>
                </div>
                <div class="row mt-1" style="margin-bottom:5px">
                    <div class="col-lg-3">
                        <label style="font-weight:bolder;">Check List
                            <sup class="super-script me-1">*</sup></label>
                    </div>
                    <div class="col-lg-7">
                        <ng-select [(ngModel)]="documentList.documentNameLid" [items]="DocumentName" *ngIf="!(documentList.id!='00000000-0000-0000-0000-000000000000'&&documentList.id!=undefined&&documentList.id!=null)"
                            (change)="inputChangeValue()" bindLabel="label" bindValue="value">
                        </ng-select>   
                        <ng-select [(ngModel)]="UpdateDocumentBO.documentNameLid" [items]="DocumentName" *ngIf="documentList.id!='00000000-0000-0000-0000-000000000000'&&documentList.id!=undefined&&documentList.id!=null"
                        (change)="inputChangeValue()" bindLabel="label" bindValue="value">
                    </ng-select>            
                    </div>
                    <div class="col-lg-2 mt-1">
                        <button type="button" class="btn btn-sm" data-bs-toggle="modal" 
                            data-bs-target="#DocumentsLov">
                            <label>Add check List</label>
                        </button>
                    </div>
                </div>
                <div class="row" style="margin-bottom:5px">
                    <div class="col-lg-3">
                        <label style="font-weight:bolder;">Title
                            <sup class="super-script me-1">*</sup></label>
                    </div>
                    <div class="col-lg-7">
                        <input type="text" class="w-100" class="form-control" (change)="inputChangeValue()"
                            [(ngModel)]="documentList.documentTitle" />
                    </div>
                </div>
                <div class="row" style="margin-bottom: 5px;">
                    <div class="col-lg-3">
                        <label style="font-weight: bolder;">Valid till</label>
                    </div>
                    <div class="col-lg-7 mt-1">                
                      <my-date-picker [options]="myDatePickerOptions" placeholder="mm/dd/yyyy" [selDate]="documentList.validTill"
                      (inputFieldChanged)="newdates($event, 'inputchanged', 'Startdate')"
                      (dateChanged)="newdates($event, 'datechanged', 'Startdate')">
                    </my-date-picker>
                    </div>
                </div>
                <div class="row" style="margin-bottom: 5px;">
                    <div class="col-lg-3">
                        <label style="font-weight: bolder;">MN Choice Assessment</label>
                    </div>
                    <div class="col-lg-7 mt-1">
                        <input type="checkbox" [(ngModel)]="documentList.isMNChoiceAssessment" />
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <ng-container *ngIf="DocumentRelation.isDocumentVerified== 'Client' && !(documentList.id!='00000000-0000-0000-0000-000000000000'&&documentList.id!=undefined&&documentList.id!=null)">
                    <button class="btn btn-sm btn-primary" type="button" [disabled]="selectedDocumentFileName=='' || selectedDocumentFileName==null || selectedDocumentFileName==undefined
            || documentList.documentNameLid=='00000000-0000-0000-0000-000000000000' ||documentList.documentNameLid ==null || documentList.documentNameLid==undefined ||documentList.documentNameLid==''
            || documentList.documentTitle=='' || documentList.documentTitle==null || documentList.documentTitle==undefined
            ||isField" (click)="SaveClientDocument(documentList)">Save &
                        Close</button>&nbsp;&nbsp;
                </ng-container>
                <ng-container *ngIf="DocumentRelation.isDocumentVerified== 'Employee' && !(documentList.id!='00000000-0000-0000-0000-000000000000'&&documentList.id!=undefined&&documentList.id!=null)">
                    <button class="btn btn-sm btn-primary" type="button" [disabled]="selectedDocumentFileName=='' || selectedDocumentFileName==null || selectedDocumentFileName==undefined
            || documentList.documentNameLid=='00000000-0000-0000-0000-000000000000' ||documentList.documentNameLid ==null || documentList.documentNameLid==undefined ||documentList.documentNameLid==''
            || documentList.documentTitle=='' || documentList.documentTitle==null || documentList.documentTitle==undefined 
                ||isFieldDisabled" (click)="SaveEmployeeDocument(documentList)">Save &
                        Close</button>&nbsp;&nbsp;
                </ng-container>
                <button type="button" class="btn btn-sm btn-primary"  [disabled]="isField || documentList.documentTitle=='' || documentList.documentTitle==null || documentList.documentTitle==undefined||
                UpdateDocumentBO.documentNameLid=='00000000-0000-0000-0000-000000000000' ||UpdateDocumentBO.documentNameLid ==null || UpdateDocumentBO.documentNameLid==undefined ||UpdateDocumentBO.documentNameLid==''"
                 *ngIf="documentList.id!='00000000-0000-0000-0000-000000000000'&&documentList.id!=undefined&&documentList.id!=null" (click)="UpdateClientEmployeeDocTitle()">Update & Close</button>
                <button type="button" class="btn btn-sm btn-primary" (click)="clientDocumentClose()">Close</button>
            </div>
        </div>
    </div>
</div>

<!--Close without save-->
<span id="cancelmodal" data-bs-target="#Closemodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="Closemodal" data-bs-backdrop="static">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Close</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"> </span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <label>Do you want to close without save ?</label>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="goback()">Yes</button>
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">No</button>
            </div>
        </div>
    </div>
</div>
<span id="deletedocument" data-bs-toggle="modal" data-bs-target="#deletedoc"></span>
<div class="modal hide fade modalbackgrod" id="deletedoc" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog  ">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Delete Record</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"> </span>
                </button>
            </div>
            <div class="modal-body ">
                Do you want to delete this record ?
            </div>
            <div class="modal-footer">
                <button type="button" *ngIf="DocumentRelation.isDocumentVerified== 'Client'"
                    class="btn btn-sm btn-primary" (click)="deleteClientDocument()">Yes</button>
                <button type="button" *ngIf="DocumentRelation.isDocumentVerified== 'Employee'"
                    class="btn btn-sm btn-primary" (click)="deleteEmployeeDocument()">Yes</button>
                <button type="button" class="btn btn-sm btn-primary" data-bs-dismiss="modal">No</button>
            </div>
        </div>
    </div>
</div>
<span id="DocumentsLovopen" data-bs-toggle="modal" data-bs-target="#DocumentsLov"></span>
<div class="modal hide fade modalbackgrod" id="DocumentsLov" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog ">
        <form [formGroup]="lovForm">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title font-header" id="exampleModalLabel">New Check List</h5>
                    
                   
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="clearlov()">
                        <span aria-hidden="true"> </span>
                    </button>
                </div>
                <div class="modal-body ">
                    <div class="row">
                        <div class="col-lg-6">
                            <label style="font-weight: 600;margin-top:6px;">Check List Name
                                <sup class="super-script mr-1">*</sup></label>
                        </div>
                        <div class="col-lg-6">
                            <input type="text" class="form-control" formControlName="Name" [(ngModel)]="Lov.lovName"
                                name="Name">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6">
                            <label style="font-weight: 600;margin-top:6px;">Required
                                </label>
                        </div>
                        <div class="col-lg-6 mt-1">
                            <input type="checkbox" formControlName="isRequired"  [(ngModel)]="Lov.isRequired" />
                        </div>
                    </div>

                </div>
                <div class="modal-footer">
                    <button class="btn btn-sm btn-primary" type="button" [disabled]="!lovForm.valid"
                        (click)="saveLov(Lov);clearlov()">Save
                        &
                        Close</button>&nbsp;&nbsp;
                    <button type="button" class="btn btn-sm btn-primary" data-bs-dismiss="modal"
                        (click)="clearlov()">Close</button>
                </div>
            </div>
        </form>
    </div>
</div>
<!-- View Template -->
<span id="openViewModal" data-bs-target="#viewDocumentmodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="viewDocumentmodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header card-show">
                <div class="col-lg-3">
                    <h5 class="modal-title font-header" id="exampleModalLabel">View Document<span>
                        </span> </h5>
                </div>
                <div class="col-lg-8" style="text-align:right">
                    <button type="button" class="btn blue-btn btn-sm text_right ms-1 mb-1 "
                    (click)="downloadFile(this.ViewedFile)">Download</button>
                    <button type="button" class="btn blue-btn btn-sm text_right ms-1 mb-1 "
                        data-bs-dismiss="modal">Close</button>
                </div>
            </div>
            <div class="modal-body" *ngIf="pdfsrc!=null && pdfsrc!=undefined && pdfsrc!=''">
                <iframe [src]="pdfsrc" width="100%" height="600px"></iframe>

            </div>
            <div class="modal-footer">
            </div>
        </div>
    </div>
</div>